import worker from '@/web-worker/main';
import Vue from 'vue'
const start = Date.now()
const genoVer = require('./genoVersion.json')
import localforage from '@/plugins/localforage'
localforage.config({
    driver: localforage.INDEXEDDB,
    name: 'localforage',
    storeName: 'genoplot',
});

import {
    markdownTable
} from 'markdown-table'
Vue.prototype.$genoVer = genoVer.version;
Vue.prototype.$forage = localforage;
Vue.prototype.$mdtable = markdownTable;
Vue.prototype.$genoChanges = genoVer.changes
if (typeof(worker) != 'undefined') {
    Vue.prototype.$worker = worker
}
/*import Zendesk from '@dansmaculotte/vue-zendesk'
Vue.use(Zendesk, {
    key: 'f9bb9526-968a-4bd1-a0bf-d41679c5352e',
    disabled: true,
    hideOnLoad: true,
    settings: {
        webWidget: {
            color: {
                theme: '#E65929'
            },
            zIndex: 10
        }
    }
})
import { createPinia } from 'pinia'
Vue.use(createPinia())
console.log('createPinia', createPinia);
*/
//import VueIntercom from '@/plugins/vue-intercom';
//import MediumEditor from 'vue2-content-editor'
//Vue.component('medium-editor', MediumEditor)
//import 'medium-editor/dist/css/medium-editor.css'
//import 'vue2-content-editor/src/themes/default.css'
//import editor from 'vue2-medium-editor'
//Vue.component('medium-editor', editor)
//Vue.prototype.$editor = editor 

import VueQuillEditor from 'vue-quill-editor'
import {
    get,
    set,
    keys,
    setMany,
    del,
    delMany,
    getMany
} from '@/plugins/idb-keyval';
Vue.prototype.$indexedDB = {
    get,
    set,
    keys,
    setMany,
    del,
    delMany,
    getMany
}
import {
    compressToUTF16,
    decompressFromUTF16
} from "async-lz-string";
window.compressToUTF16 = compressToUTF16;
window.decompressFromUTF16 = decompressFromUTF16;
let lz = {
    compress: compressToUTF16,
    decompress: decompressFromUTF16
}
Vue.use(lz)
Vue.prototype.$lz = lz
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll)
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
import yamljs from 'yamljs'
Vue.prototype.$yaml = yamljs
import retry from 'retry'
Vue.prototype.$retry = retry
import {
    isMobile
} from 'mobile-device-detect';
Vue.prototype.$isMobile = isMobile;

Vue.use(VueQuillEditor, /* { default global options } */ )
import dbCache from '@/plugins/indexDBCache.js';
Vue.use(dbCache);
Vue.prototype.$dbCache = dbCache

import {
    store
} from "./Store"
store.commit('change', {
    contacted: false
})
import gitinfo from './git.js'
import vueCustomScrollbar from 'vue-custom-scrollbar'
Vue.use(vueCustomScrollbar)
import VueResize from 'vue-resize'
import hexUtils from './plugins/hexutils'
Vue.mixin(hexUtils);
import Toasted from '@/components/toasted';
Vue.use(Toasted, {
    iconPack: 'fontawesome'
})
Vue.toasted.register('web_worker_error', 'Your browser is out of date!<br/>Please update your browser so we can continue to provide our services securely.', {
    type: 'error',
    fullWidth: true,
    fitToScreen: true,
    singleton: true,
    icon: {
        name: 'fa-circle-exclamation',
        after: true
    },
    position: "bottom-center",
    className: 'BrowserError',
    action: {
        text: 'CLOSE',
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        }
    },
})
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
let toastedOptions = {
    type: 'error',
    icon: 'error_outline',
    enableHtml: true
};

// register the toast with the custom message
Vue.toasted.register('genoError',
    (payload) => {

        // if there is no message passed show default message
        if (!payload.message) {
            return "Oops.. Something Went Wrong.."
        }

        // if there is a message show it with the message
        return "payload.message";
    },
    toastedOptions
)
Vue.use(VueResize)
import 'vue-resize/dist/vue-resize.css'
import zlib from 'zlib'
Vue.prototype.$zlib = zlib;
import App from "./App.vue";
import {
    AmplifyEventBus
} from './plugins/aws-amplify-vue';

async function updateAmplifyConfigWithAccessToken() {
    try {
        const session = await Auth.currentSession();
        const accessToken = session.getAccessToken().getJwtToken();
        Amplify.configure({
            API: {
                "aws_cognito_region": process.env['VUE_APP_aws_cognito_region'],
                "aws_user_pools_id": process.env['VUE_APP_aws_user_pools_id'],
                "aws_user_pools_web_client_id": process.env['VUE_APP_aws_user_pools_web_client_id'],
                "aws_appsync_graphqlEndpoint": process.env['VUE_APP_aws_appsync_graphqlEndpoint'],
                "aws_appsync_region": process.env['VUE_APP_aws_appsync_region'],
                "aws_appsync_authenticationType": process.env['VUE_APP_aws_appsync_authenticationType'],
                GraphQL: {
                    headers: async () => ({
                        'My-Custom-Header': `${accessToken}`
                    })
                }
            }
        });
        console.log('Amplify reconfigured with access token');
    } catch (error) {
        console.error('Error fetching access token:', error);
    }
}

import {
    Hub
} from 'aws-amplify';
Hub.listen('auth', (data) => {
    const {
        payload
    } = data;
    if (payload.event === "cognitoHostedUI") {
        console.log('User signed in via Social Provider');
        AmplifyEventBus.$emit('authState', 'socialSignIn')
    } else if (payload.event === 'signIn_failure' && payload.message == 'The OAuth response flow failed') {
        let message = payload.data && payload.data.message ? payload.data.message : 'Sign In Failed!';
        if (message == 'User+is+not+enabled') {
            console.log('hub event', message)
            let params = {
                className: 'toastDiaabledUser toastError',
                message: 'Your account has been diaabled as a precaution<br>due to unusual activity on your account.<br><br>Please contact us if you feel this action was erroneous.<br>',
                toast: true,
                position: 'top-center',
                timestamp: Date.now(),
            }
                let sendEvent = {
                    exec: 'setError',
                    type: 'appEvents',
                    component: 'signInModal',
                    timestamp: Date.now(),
                    params: 'Account is disabled'
                }
            localStorage.setItem('lastToast', JSON.stringify(params))
            localStorage.setItem('lastEvent', JSON.stringify(sendEvent))
            AmplifyEventBus.$emit('appEvents', {
                exec: 'showToast',
                component: 'nav',
                params: params
            })
            AmplifyEventBus.$emit('appEvents', {
                exec: 'setError',
                component: 'signInModal',
                params: 'Account is disabled'
            });
        } else {
            AmplifyEventBus.$emit('appEvents', {
                exec: 'setError',
                component: 'signInModal',
                params: message
            });
        }
    }
});
Vue.prototype.$eventBus = AmplifyEventBus;
import router from "./router";
import introJs from 'intro.js/intro.js';
const introjs = introJs()
introjs.setOption("overlayOpacity", 0.5)
introjs.setOption("keyboardNavigation", false)
introjs.setOption("exitOnOverlayClick", false)
introjs.setOption("scrollToElement", false)
introjs.setOption("scrollTo", "tooltip")
introjs.setOption("hidePrev", false)
introjs.setOption("hideNext", false)
introjs.setOption("skipLabel", "Cancel")
import "@/style/introjs.min.css"
import "@/style/introjs-nassim.css"
Object.defineProperty(Vue.prototype, '$intro', {
    value: introjs
});
import useStepAudioContext from '@/plugins/useStepAudioContext';
Vue.use(useStepAudioContext);
import {
    Howl,
    Howler
} from 'howler';
Object.defineProperty(Vue.prototype, '$howl', {
    value: Howl
});
Object.defineProperty(Vue.prototype, '$howler', {
    value: Howler
});
import "./registerServiceWorker";
import GenoLogo from './svg/icon-glogo.svg';
import selectable from 'vue-selectable';
import GenoSpinner from './components/GenoSpinner.vue'
import VueMarkdown from 'vue-markdown'
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: {
        //id: "G-8V4DYE39MP",
        id: "UA-162020428-1",
        globalObjectName: 'tagEvents',
        params: {
            'user_id': store.getters.user ? store.getters.user.username : null
        },
        pageTrackerTemplate(to) {
            return {
                screen_name: to.name,
                user_id: store.getters.user ? store.getters.user.username : null,
            }
        }
    }
}, router);
//plugins
import GenoUI from './plugins/default';
import {
    ReactiveBase,
    DataSearch,
    ReactiveList,
    MultiList,
    SelectedFilters,
    SingleList
} from "@appbaseio/reactivesearch-vue";
Vue.use(ReactiveBase);
Vue.use(ReactiveList);
Vue.use(MultiList);
Vue.use(SingleList);
Vue.use(DataSearch);
Vue.use(SelectedFilters);
import Amplify, * as AmplifyModules from 'aws-amplify';
//import Amplify from '@aws-amplify/core';
//import AmplifyModules from '@aws-amplify/core';
import {
    AmplifyPlugin
} from './plugins/aws-amplify-vue';
import aws_exports from './aws-exports';
import VModal from './components/vModal';
import VueForm from 'vue-form';
Amplify.configure(aws_exports);
import {
    VueSpinners
} from '@saeris/vue-spinners'
import {
    Auth
} from '@aws-amplify/auth';
//import { Auth } from 'aws-amplify'
//import { Auth } from 'aws-amplify/auth';
Auth.configure({
    storage: window.localStorage
})
//import { Auth } from 'aws-amplify';
Vue.prototype.$auth = Auth
Vue.prototype.$tempstate = {}
import apolloProvider from "@/appsync";
import Multiselect from '@/components/multiselect'
import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)
import {
    Tree,
    Progress,
    Select,
    Option,
    Tabs,
    Radio,
    RadioGroup,
    RadioButton,
    Drawer,
    TabPane
} from 'element-ui'
import {
    VueContext
} from 'vue-context';
//import { decompress as lzStringDecompress } from 'lz-string'
import LZString from 'lz-string'
import VTooltip from 'v-tooltip'
import VueNumberInput from '@chenfengyuan/vue-number-input';
Vue.use(VueNumberInput);
import VueAwesomeSwiper from '@/components/swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);
import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)
var juice = require('juice/client')
window.juice = juice
Vue.component('multiselect', Multiselect)
Vue.component('vue-context', VueContext)
Vue.component('geno-logo', GenoLogo)
Vue.component('geno-spinner', GenoSpinner)
Vue.component('vue-markdown', VueMarkdown)
Vue.component('vue-custom-scrollbar', vueCustomScrollbar)
Vue.directive('selectable', selectable);
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Progress)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(GenoUI)
Vue.use(VueForm)
Vue.use(Drawer)
Vue.use(VTooltip, {
    autoHide: true,
    defaultOffset: 5,
    defaultHideOnTargetClick: true,
    defaultTrigger: 'hover',
    defaultDelay: {
        show: 300,
        hide: 100
    }
})
//Vue.use(VTooltip, {autoHide:false, defaultOffset: 5, defaultHideOnTargetClick: false, defaultTrigger: 'click', defaultDelay: { show: 300, hide: 100 } })
Vue.use(LZString)
Vue.use(AmplifyPlugin, AmplifyModules, Auth);
Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    defaultProps: {
        draggable: true,
    },
    injectModalsContainer: true
})

Vue.use(VueSpinners)
Vue.config.productionTip = false;
new Vue({
    store,
    router,
    //vuetify,
    apolloProvider,
    render: h => h(App),
    created() {
        if (sessionStorage.redirect) {
            const redirect = sessionStorage.redirect
            delete sessionStorage.redirect
            this.$router.push(redirect)
        }
    },
}).$mount("#app");

store.commit('change', {
    graphQLurl: aws_exports.aws_appsync_graphqlEndpoint
});
const ifObjectisJSON = function(obj) {
    return (typeof obj === 'object' && obj !== null && obj.constructor === Object) || Array.isArray(obj)
}

function CacheDB(namespace, prefix, config) {
    this.config = config || {
        auto: 0
    };
    this.config.auto = this.config.auto || 0
    this.namespace = namespace || "CacheDBDefaultNameSpace";
    this.prefix = prefix || "CacheDBDefaultPrefix";
    this.read = async function(key, config) {
        config = config || {};
        config.type = config.type || (this.config.auto ? "auto" : "text");
        return new Promise((resolve, reject) => {
            caches.open(this.namespace)
                .then(cache => {
                    cache.match(new Request(`https://${this.prefix}/${encodeURIComponent(key)}`))
                        .then(async response => {
                            if (config.type === 'auto') {
                                switch (response.headers.get('Content-Type')) {
                                    case "application/json":
                                        config.type = "json";
                                        break;
                                    case "application/octet-stream":
                                        config.type = "arrayBuffer";
                                        break;
                                    case "application/octet-stream":
                                        config.type = "blob";
                                        break;
                                    case "text/number":
                                        config.type = "number";
                                        break;
                                    case "text/boolean":
                                        config.type = "boolean";
                                        break;
                                    default:
                                        config.type = "text";
                                        break;
                                }
                            }
                            switch (config.type) {
                                case "number":
                                    resolve(Number(await response.text()));
                                    return;
                                case "json":
                                    resolve(response.json());
                                    return;
                                case "arrayBuffer":
                                    resolve(response.arrayBuffer());
                                    return;
                                case 'blob':
                                    resolve(response.blob());
                                    return;
                                case 'text':
                                    resolve(response.text());
                                    return;
                                case 'boolean':
                                    resolve(await response.text() == 1);
                                    return;
                                default:
                                    resolve(response.body);
                                    return;
                            }
                        })
                })
                .catch(err => {
                    console.error('CacheDB Read Erorr:' + err);
                    reject(null);
                });
        })
    }
    this.write = async function(key, value, config) {
        config = config || {};
        config.type = config.type || (this.config.auto ? "auto" : "text");
        if (config.type === 'auto')
            config.type = ifObjectisJSON(value) ? 'json' : typeof value;
        switch (config.type) {
            case "json":
                config.content_type = "application/json";
                value = JSON.stringify(value);
                break;
            case "arrayBuffer":
                config.content_type = "application/octet-stream";
                break;
            case 'blob':
                config.content_type = "application/octet-stream";
                break;
            case 'number':
                config.content_type = "text/number";
                value = value.toString();
                break;
            case 'boolean':
                config.content_type = "text/boolean";
                value = value ? 1 : 0
                break;
            default:
                break;
        }
        return new Promise((resolve, reject) => {
            caches.open(this.namespace).then(cache => {
                cache.put(
                    new Request(`https://${this.prefix}/${encodeURIComponent(key)}`),
                    new Response(value, {
                        headers: {
                            'Content-Type': config.content_type
                        }
                    })).then(resolve(1))
            }).catch(err => {
                console.error('CacheDB Write Erorr:' + err);
                reject(0)
            });
        })
    }
    this.delete = async function(key) {
        return new Promise((resolve, reject) => {
            caches.open(this.namespace).then(cache => {
                    cache.delete(new Request(`https://${this.prefix}/${encodeURIComponent(key)}`))
                        .then(resolve(true))
                })
                .catch(err => {
                    console.error('CacheDB Delete Erorr:' + err);
                    reject(false)
                });
        })
    }
    this.list = async function() {
        return new Promise((resolve, reject) => {
            caches.open(this.namespace).then(cache => {
                cache.keys().then(keys => {
                    resolve(keys.map(key => decodeURIComponent(key.url.split('/').pop())));
                })
            }).catch(err => {
                console.error('CacheDB List Erorr:' + err);
                reject([])
            });
        })
    }
    this.all = async function() {
        const data = {};
        return new Promise(async (resolve, reject) => {
            this.list().then(async keys => {
                await Promise.all(keys.map(async key => {
                    data[key] = await this.read(key);
                }))
                resolve(data);
            }).catch(err => {
                console.error('CacheDB All Erorr:' + err);
                reject([])
            });
        })
    }
    this.clear = async function() {
        return new Promise((resolve, reject) => {
            this.list().then(keys => {
                keys.forEach(key => {
                    this.delete(key)
                })
                resolve(true);
            }).catch(err => {
                console.error('CacheDB Clear Erorr:' + err);
                reject(false)
            });
        })
    }
    this.destroy = async function() {
        return new Promise((resolve, reject) => {
            this.clear().then(() => {
                caches.delete(this.namespace).then(resolve(true));
            }).catch(err => {
                console.error('CacheDB Destroy Erorr:' + err);
                reject(false)
            });
        })
    }
}
